import ApiClass from "../../api/index";

export default {
  /**
   * Retorna a última versão do sistema
   * @returns (Promise) versão do sistema
   */
  async getVersion() {
    try {
      const getApi = () => new ApiClass();;
      const response = await getApi().getVersaoApi().UltimaVersao();
      if (!response) {
        return "0.0.0";
      }
      return response as any;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      return "0.0.0";
    }
  },
};

